import PrivacyContainer from './PrivacyContainer';
export default PrivacyContainer;
